// switch1Reducer.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  // checked: false, // Default value
};

const switch1Slice = createSlice({
  name: 'switch1',
  initialState,
  reducers: {
    reset4Switch1() {
      return initialState;
    },
  },
});

export const { reset4Switch1 } = switch1Slice.actions;
export default switch1Slice.reducer;
// const initialState = {
//   // checked: false, // Default value
// };

// export default function switch1Reducer(state = initialState, action) {
//   switch (action.type) {
//     // case 'setChecked':
//     //   return {
//     //     ...state,
//     //     checked: action.payload, // Update the selected book
//     //   };
//     case 'reset4Switch1':
//       return initialState;          
//     default:
//       return state;
//   }
// }

// // export const setChecked = (e) => ({
// //   type: 'setChecked',
// //   payload: e,
// // });

// export const reset4Switch1  = (e) => ({
//   type: 'reset4Switch1',
//   payload: e,
// });